import {EntityBase} from "../../shared/entity/EntityBase";

const SHOP_PACKAGE_TABLE_FIELDS = {
    index: { type: Number, defaultValue: 0 },
    openChk: { type: Number, defaultValue: 0 },
    groupIdx: { type: Number, defaultValue: 0 },
    productType: { type: Number, defaultValue: 0 },
    subType: { type: Number, defaultValue: 0 },
    subTypeValue: { defaultValue: '' },
    missionGroup: { type: Number, defaultValue: 0 },
    reBuy: { type: Number, defaultValue: 0 },
    packageTime: { type: Number, defaultValue: 0 },
    memo: { defaultValue: '' },
    isFav: { type: Number, defaultValue: 0 },
}

export class ShopPackageTableEntity extends EntityBase {
    constructor(data = {}) {
        super(data, SHOP_PACKAGE_TABLE_FIELDS);

        this.errors = [
            {condition: () => this.index === 0, message: '인덱스가 없습니다.'},
        ];
    }
}